import { InjectionToken } from '@angular/core';

export const IOTEQ_APP_CONFIG = new InjectionToken<any>('IOTEQ_APP_CONFIG');
